import { HttpClient } from '../httpClient';
import GradesResponse from '../responses/gradesResponse';

const httpClient = new HttpClient();

export const getGrades = async () => {
  return httpClient.get<GradesResponse>({
    url: '/v1/grades',
    requiresToken: true,
  });
};
